import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Stack } from '@mui/material';
import { Home as HomeIcon } from '@mui/icons-material';
import NavigationBar from './NavigationBar';

// Catch-all (`*`) route target. The SPA rewrite (render.yaml / _redirects)
// sends every unknown path to index.html; without this, unmatched routes
// rendered a blank screen (UX-3 in docs/STATUS.md).
function NotFound() {
    return (
        <Box sx={{ minHeight: '100vh', backgroundColor: '#121212' }}>
            <NavigationBar />
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    px: 3,
                    py: 12,
                }}
            >
                <Typography variant="h2" sx={{ fontWeight: 700, color: 'rgba(144,202,249,0.85)' }}>
                    404
                </Typography>
                <Typography variant="h6" sx={{ color: 'rgba(255,255,255,0.85)', mt: 1 }}>
                    Page not found
                </Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.5)', mt: 1, maxWidth: 420 }}>
                    The page you’re looking for doesn’t exist or may have moved.
                </Typography>
                <Stack direction="row" spacing={1.5} sx={{ mt: 3 }}>
                    <Button component={RouterLink} to="/" variant="contained" size="small" startIcon={<HomeIcon />}>
                        Back to Cockpit
                    </Button>
                    <Button component={RouterLink} to="/msa" variant="outlined" size="small">
                        MSA Studies
                    </Button>
                </Stack>
            </Box>
        </Box>
    );
}

export default NotFound;
